import * as styles from './style.css'

export const LayoutPortal = () => {
  return (
    <div className={styles.layoutPortal}>
      <div id="portal-modal" className={styles.layoutPortal_modal} />
    </div>
  )
}
